import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { SplashCursor } from '../components/SplashCursor';
import { useTheme } from '../theme/ThemeContext';
import { useTranslation } from 'react-i18next';

let THEME = {};
const getStyles = () => StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: THEME.bg,
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    },
    backgroundContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
    },
    content: {
        alignItems: 'center',
        zIndex: 1,
        padding: 24,
        maxWidth: 600,
        backgroundColor: THEME.bgCard,
        backdropFilter: 'blur(10px)',
        borderRadius: 40,
        borderWidth: 1,
        borderColor: THEME.border,
        boxShadow: '0 0 100px rgba(59, 130, 246, 0.1)',
    },
    errorCode: {
        fontSize: 120,
        fontWeight: '900',
        color: 'transparent',
        backgroundImage: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        marginBottom: -10,
        fontFamily: 'Outfit, sans-serif',
        letterSpacing: -5,
    },
    title: {
        fontSize: 32,
        fontWeight: '800',
        color: THEME.textPrimary,
        marginBottom: 16,
        fontFamily: 'Outfit, sans-serif',
        textAlign: 'center',
    },
    subtitle: {
        fontSize: 18,
        color: THEME.textSecondary,
        textAlign: 'center',
        lineHeight: 28,
        marginBottom: 40,
        fontWeight: '400',
    },
    button: {
        backgroundColor: '#3b82f6',
        paddingVertical: 18,
        paddingHorizontal: 36,
        borderRadius: 100,
        boxShadow: '0 10px 30px rgba(59, 130, 246, 0.4)',
    },
    buttonText: {
        color: '#fff',
        fontWeight: '700',
        fontSize: 14,
        letterSpacing: 2,
    },
    footer: {
        position: 'absolute',
        bottom: 40,
        zIndex: 1,
    },
    footerText: {
        color: THEME.textMuted,
        fontSize: 12,
        fontWeight: '500',
        letterSpacing: 1,
        textTransform: 'uppercase',
    },
});
let styles = getStyles();

const NotFoundScreen = () => {
    const navigate = useNavigate();
    const { theme } = useTheme();
    const { t } = useTranslation();
    Object.assign(THEME, theme);
    styles = getStyles();

    return (
        <View style={styles.container}>
            {/* Background animation */}
            <View style={styles.backgroundContainer}>
                <SplashCursor
                    BACK_COLOR={{ r: 0.05, g: 0.05, b: 0.05 }}
                    COLOR_UPDATE_SPEED={2}
                    SPLAT_RADIUS={0.4}
                    DENSITY_DISSIPATION={2.0}
                />
            </View>

            <View style={styles.content}>
                <Text style={styles.errorCode}>404</Text>
                <Text style={styles.title}>{t('app.not_found.title')}</Text>
                <Text style={styles.subtitle}>{t('app.not_found.subtitle')}</Text>

                <TouchableOpacity
                    style={styles.button}
                    onPress={() => navigate('/')}
                >
                    <Text style={styles.buttonText}>{t('app.not_found.return')}</Text>
                </TouchableOpacity>
            </View>

            <View style={styles.footer}>
                <Text style={styles.footerText}>{t('app.not_found.footer')}</Text>
            </View>
        </View>
    );
};


export default NotFoundScreen;
